module.exports = __webpack_public_path__ + "09e9768198a903a16c59a85904296ff6.svg";